var render = function render(_c,_vm){return _c('td',{staticClass:"d-none d-md-table-cell"},[(_vm.props.track.albumId && !_vm.props.share)?[_c('router-link',{attrs:{"to":{name: 'album', params: {id: _vm.props.track.albumId}}},nativeOn:{"click":function($event){$event.stopPropagation();}}},[_vm._v(" "+_vm._s(_vm.props.track.album)+" ")])]:[_vm._v(" "+_vm._s(_vm.props.track.album)+" ")]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }